import { Component, Input, SimpleChanges, OnChanges, ViewEncapsulation } from '@angular/core';
import { AboutCity } from '../../models/about-city.model';
@Component({
  selector: 'about-city',
  templateUrl: './about-city.component.html',
  styleUrls: ['./about-city.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class AboutCityComponent implements OnChanges{
  @Input("item") item:AboutCity;
  @Input("position") position:string;
  @Input("index") index:number;
  public colorIMG:string = '/assets/images/colours.png';

  constructor(){};
  public ngOnChanges(changes:SimpleChanges){
  }
}